import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'upload-document-selection',
  templateUrl: './upload-document-selection.component.html',
  styleUrl: './upload-document-selection.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadDocumentSelectionComponent implements OnInit {
  isInputFocused = false;
  loader = false;
  @Input() disableSearch = false;
  searchText = '';
  textBoxPlaceHolder = 'Search Kinnect';
  connectionUserFormControl = new UntypedFormControl();
  @Output() uploadDocumentSelectionEmitter = new EventEmitter<any>();
  @Input() nonDocumentAttachmentList: any[] = [];
  @ViewChild(MatAutocompleteTrigger) matAutocomplete: MatAutocompleteTrigger;
  constructor(private cd: ChangeDetectorRef) {}

  ngOnInit(): void {
    if (this.disableSearch) {
      this.connectionUserFormControl.disable();
    }
  }
  onInputFocus() {
    this.isInputFocused = true;
    if (!this.connectionUserFormControl.value) {
    }
  }
  nmaterialIconName(element) {
    if (element.display_file_name == undefined) {
      return 'doc';
    }
    let type = element.display_file_name.replace(/^.*\./, '') != element.display_file_name ? element.display_file_name.replace(/^.*\./, '') : '';
    if (type == '') {
      return 'doc';
    } else {
      return type.toLowerCase();
    }
  }
  onFileSelected(event, file) {
    this.searchText = '';
    this.uploadDocumentSelectionEmitter.emit({
      type: 'onFileSelected',
      data: file,
      event: event,
    });
    this.matAutocomplete.closePanel();
  }
  openFileUpload() {
    this.uploadDocumentSelectionEmitter.emit({
      type: 'openFileUpload',
    });
    this.matAutocomplete.closePanel();
  }
  onInputBlur() {
    this.isInputFocused = false;
  }

  clearInput() {
    this.connectionUserFormControl.setValue('');
  }

  async onMemberSearch(searchValue: string) {
    this.isInputFocused = true;
    this.loader = true;
    this.searchText = searchValue;
    this.cd.detectChanges();
  }
}
